import { controls, currencyToNumber, grouped } from "../../controls";

const rpcf1 = {
  label: "Funds Status",
  starting: true,
  url: "rp101m",
  pageLabel: "Funds Status",
  pageType: "history",
  visitingBranches: true,

  // filteraction: true,
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Funds Status",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "File Name",
        accessor: "display_label",
        rwidth: "*"
      },
      {
        Header: "Village",
        accessor: "village_display"
      },
      {
        Header: "Batch Number",
        accessor: "transaction_batch_number"
      },
      {
        Header: "Talathi Name",
        accessor: "talathi_name"
      },
      {
        Header: "Uploaded",
        columns: [
          {
            Header: "Total",
            accessor: "total_uploads"
          },
          {
            Header: "Success",
            accessor: "success_uploads"
          },
          {
            Header: "Failed",
            accessor: "failed_uploads"
          },
        ]
      },
      {
        Header: "Amount",
        columns: [
          {
            Header: "Total",
            accessor: "total_amount",
            type: "currency"
          },
          {
            Header: "Success",
            accessor: "amount_success",
            type: "currency"
          },
          {
            Header: "Failed",
            accessor: "amount_failed",
            type: "currency"
          },
          {
            Header: "Paid",
            accessor: "amount_paid",
            type: "currency"
          }
        ]
      },
    ]
  }
};

export default rpcf1;